import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, Resolve } from '@angular/router';
import { LoginService } from './login.service';


@Injectable()
export class RegionsListGuard implements Resolve<any> {
  constructor(
    public router: Router,
    private loginService: LoginService
  ) { }

  resolve() {
    return this.loginService.getRegionsList();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/regions-list-guard.ts